import IconButton from '@hud/web-components/DesignSystem/Components/IconButton/IconButton';
import Button from '@hud/web-components/DesignSystem/Components/Button/Button';
import { StyledConfirmDisconnectDialog } from './ConfirmDisconnectDialog.styles';

type ConfirmDisconnectDialogProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmDisconnectDialog: React.FC<ConfirmDisconnectDialogProps> = ({ opened, onClose, onConfirm }) => {
  return (
    <StyledConfirmDisconnectDialog opened={opened} onClose={onClose}>
      <div className="modal-header">
        <h2 className="modal-title">Disconnect Hud App?</h2>
        <IconButton icon="designSystem.xmark" onClick={onClose} />
      </div>
      <div className="modal-content">
        <p className="modal-description">
          Disconnecting Hud app from your Slack workspace will remove all channel
          connections.
        </p>
      </div>
      <div className="modal-actions">
        <button className="text-button" onClick={onClose}>
          Cancel
        </button>
        <Button size="small" skin="destructive" onClick={onConfirm}>
          Disconnect
        </Button>
      </div>
    </StyledConfirmDisconnectDialog>
  );
};

export default ConfirmDisconnectDialog;
